import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {InputField} from "@pg-design/inputs-module";
import {REGISTRATION_WIZARD_TEST_IDS} from "@pg-mono/test-ids";

import {useRegistrationWizardTrackingContext} from "../../hooks/use_registration_wizard_tracking_context";
import {trackRegistrationWizardButtonClick} from "../../tracking/track_registration_wizard_events";

interface IProps {
    email: string;
    onAdvance: () => Promise<void>;
}

export const RegistrationWizardEmailStepAccount = (props: IProps) => {
    const {email, onAdvance} = props;
    const trackingContext = useRegistrationWizardTrackingContext();

    const onContinue = () => {
        trackRegistrationWizardButtonClick(trackingContext, "rp_auth_continue");
        void onAdvance();
    };

    return (
        <div className={accountStyle}>
            <InputField name="email" value={email} placeholder="Podaj swój adres e-mail" disabled readOnly />
            <Button type="button" variant="filled_primary" fullWidth onClick={onContinue} dataTestId={REGISTRATION_WIZARD_TEST_IDS.EMAIL_SUBMIT_BUTTON}>
                DALEJ
            </Button>
        </div>
    );
};

const accountStyle = css({
    display: "flex",
    flexDirection: "column",
    rowGap: 3
});
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {InputField} from "@pg-design/inputs-module";
import {REGISTRATION_WIZARD_TEST_IDS} from "@pg-mono/test-ids";

import {useRegistrationWizardTrackingContext} from "../../hooks/use_registration_wizard_tracking_context";
import {trackRegistrationWizardButtonClick} from "../../tracking/track_registration_wizard_events";

interface IProps {
    email: string;
    onAdvance: () => Promise<void>;
}

export const RegistrationWizardEmailStepAccount = (props: IProps) => {
    const {email, onAdvance} = props;
    const trackingContext = useRegistrationWizardTrackingContext();

    const onContinue = () => {
        trackRegistrationWizardButtonClick(trackingContext, "rp_auth_continue");
        void onAdvance();
    };

    return (
        <div className={accountStyle}>
            <InputField name="email" value={email} placeholder="Podaj swój adres e-mail" disabled readOnly />
            <Button type="button" variant="filled_primary" fullWidth onClick={onContinue} dataTestId={REGISTRATION_WIZARD_TEST_IDS.EMAIL_SUBMIT_BUTTON}>
                DALEJ
            </Button>
        </div>
    );
};

const accountStyle = css({
    display: "flex",
    flexDirection: "column",
    rowGap: 3
});
